exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PaymentAreaWarning_actionResult_AZnY-{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;padding:12px 0 20px;width:100%}.PaymentAreaWarning_titleMain_1hui5{font-weight:700;font-size:25px;line-height:31px;text-align:center;margin:0 0 10px}.PaymentAreaWarning_titleSub_2Ghj_{font-weight:500;font-size:12px;line-height:18px;text-align:center}.PaymentAreaWarning_icon_1pavS{height:210px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
exports.locals = {
	"actionResult": "PaymentAreaWarning_actionResult_AZnY-",
	"titleMain": "PaymentAreaWarning_titleMain_1hui5",
	"titleSub": "PaymentAreaWarning_titleSub_2Ghj_",
	"icon": "PaymentAreaWarning_icon_1pavS"
};